module.exports={author:"Eleanor Eli Moss",date:"11/06/2019",publishDate:"11/06/2019",highlighted:!1,tags:"",title:"THE HAMMER"};